/* ============================================================
   orderColorView — MS-4 (TASK-880ae21c, GAP-E from OPS-3 §65):
   pure helper behind the customer order-detail «Цвет» MetaRow.

   GAP-E root cause: the row was kind-gated inside the CustomQuote
   block of OrdersPage, so PerformerCart cart legs carrying a real
   PrintColor snapshot (MS-2 checkout stamps Order.PrintColor on
   every print order) never showed it on the customer detail.

   Contract: the row follows the snapshot only — visibility is
   deliberately kind-independent (CustomQuote AND PerformerCart);
   null (product-only orders, legacy rows) keeps the row hidden.
   Blank values normalize to hidden (defensive — MS-2 checkout
   already trims and blank→null server-side). Pure; OrdersPage
   owns rendering (MetaRow styling per DESIGN-SYSTEM.md).
   ============================================================ */

export interface OrderColorRow {
  label: 'Цвет';
  value: string;
}

/** The «Цвет» MetaRow payload for the order detail; null → row hidden. */
export function orderColorRow(printColor: string | null | undefined): OrderColorRow | null {
  const value = (printColor ?? '').trim();
  return value.length > 0 ? { label: 'Цвет', value } : null;
}

/* ecfe2257 (Artem 2026-08-28 §5): mode rows — a multicolor/any pin without a
   concrete color still deserves a visible «Цвет» line so both parties see
   the contract («уточняется в переписке» / «любой»). 0/undefined = legacy
   any-color → hidden (byte-identical old behavior); a concrete color keeps
   the row above (no suffix). */
export function orderColorModeRow(
  printColor: string | null | undefined,
  printColorMode: number | null | undefined,
): OrderColorRow | null {
  if ((printColor ?? '').trim().length > 0) return null;
  if (printColorMode === 1) return { label: 'Цвет', value: 'Многоцветная — слоты уточняются в переписке' };
  if (printColorMode === 2) return { label: 'Цвет', value: 'Любой цвет' };
  return null;
}
